var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMichelle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 282.23 603.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .eyes{display:none;}.cls-michelle-1{fill:#e2af94;}.cls-michelle-2{fill:#72451d;}.cls-michelle-3{fill:#7f5021;}.cls-michelle-4{clip-path:url(#clip-michelle-path);}.cls-michelle-5{fill:#d59d84;}.cls-michelle-6{fill:#08101e;}.cls-michelle-7{fill:#4b80a9;}.cls-michelle-8{fill:#095780;}.cls-michelle-9{fill:#c0bfbe;}.cls-michelle-10{fill:none;stroke:#dcdcdc;stroke-miterlimit:10;stroke-width:0.81px;}.cls-michelle-11{fill:#7f271b;}.cls-michelle-12{fill:#f3ad00;}.cls-michelle-13{fill:#c33131;}.cls-michelle-14{fill:#ae1912;}.cls-michelle-15{fill:#fff;}.cls-michelle-16{fill:#070707;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-michelle-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-michelle-1",
    d: "M171.42,126.07s-2.66,41.35,11.89,51L237,218s10.18,5.93,12.38,11.36c0,0,17.83,23.56,25.33,49.49s11.89,143.1-10.63,164l-.92.83c-23.49,20.66-93.13,44.3-77.49,20,15.85-24.61,31.28-28.78,30.45-43.37s-2.51-32.12-2.51-32.12L193,465.81S164,485.39,131.49,485,23.89,308.55,23.89,308.55s14.6-35,15-46.71,7.09-50.46,20-53S171.42,126.07,171.42,126.07Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-michelle-2",
    x: 168.8,
    y: 127.93,
    width: 24.58,
    height: 42.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-michelle-3",
    d: "M114.93,200S72.31,213.9,71,229.72s-15.79,33.8-15.79,33.8c.34-13.27-21-26.2-25.19-41.82s16.63-37.45,20.83-46.52S38.94,152,36.25,146s-.5-12.93-.5-12.93-2-.51-4.37-7.23,1.52-15.45,6.22-24.35.33-29.55,4.7-41.31c2.42-6.51,6.4-21,16.56-32.73,0,0,29-12.14,38.67-3.06S141.12,169.75,114.93,200Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-michelle-1",
    d: "M171.42,126.07s-2.66,41.35,11.89,51L237,218s10.18,5.93,12.38,11.36c0,0,17.83,23.56,25.33,49.49s11.89,143.1-10.63,164l-.92.83c-23.49,20.66-93.13,44.3-77.49,20,15.85-24.61,31.28-28.78,30.45-43.37s-2.51-32.12-2.51-32.12L193,465.81S164,485.39,131.49,485,23.89,308.55,23.89,308.55s14.6-35,15-46.71,7.09-50.46,20-53S171.42,126.07,171.42,126.07Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-michelle-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-michelle-5",
    d: "M102.66,190.4l4.42,12.83S152,190.75,168.32,152.6l25.43-2.88-11.06-29.18S115.48,144.86,102.66,190.4Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-michelle-5",
    points: "199.36 442.19 193.34 469.97 158.4 465.67 158.4 441.9 199.36 442.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-michelle-6",
    d: "M168.89,303.84s11.63-40.93,17.88-49.76l-1.08-2.37S173,265.28,163.5,302.55c0,0-50,38.56-59.46,48s11.64,88.11,17.88,91.34,53.1,24.57,76.36,5l15.37-58.69-4.05-11.34s-7.11,8-18.31.87S166.73,324.31,168.89,303.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-michelle-1",
    d: "M12,351.07S-3.59,483.62.76,509c19.08,111.23,41,1,45.66-7.25S37.57,360.8,12,351.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-michelle-6",
    d: "M94,201.42S80.36,225.5,71.07,250C63,271.23,53,301.36,53,301.36l-6.65,1.38S67.1,234.33,93.11,192.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-michelle-7",
    d: "M117.65,320.14A397.54,397.54,0,0,0,68.6,303.3c-25.25-6.62-34.35-6.45-41.3-3.93-35.64,12.91-1.08,141.06,1.58,145.85,3.82,6.88-12.37,71.57-10.11,82.64l184.7.46L196.89,465s-24.36,9.89-43.41-37.12C148.78,416.32,111.5,354.45,117.65,320.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-michelle-8",
    d: "M19.63,327s12.19,14.52,18.49,19.73C52.31,358.4,88.28,354.9,93.62,359L115,449.53s-71-7.39-79.39-17.24C19.68,413.6,19.63,327,19.63,327Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-michelle-9",
    cx: 103.03,
    cy: 326.25,
    rx: 5.86,
    ry: 5.13,
    transform: "translate(-238.06 352.95) rotate(-76.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-michelle-10",
    d: "M110.38,301.89s-4.76-.48-4.13,2.65,3.81,5.23,2.62,7.73-5.77,7-4.52,8.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-michelle-10",
    d: "M123.6,311.68s2.26,4.77-.36,5.82-5.88-1.85-7.73-.65-2.88,7.95-7.45,7.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-michelle-10",
    d: "M28.84,304.12c1.63.73,3.4-.24,4.73-2,2.52-3.27,4.93-3.82,6.22-4,5.33-.68,7-5,3.83-7.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-michelle-10",
    d: "M35.45,291.43s-5.27.34-4.44,3.89-5.65,6.44-4.92,7.79"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-michelle-9",
    cx: 27.28,
    cy: 305.2,
    rx: 4.37,
    ry: 2.7,
    transform: "translate(-250.67 176.22) rotate(-60)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-michelle-7",
    d: "M29.29,450.69s-21.4,86.94-20,145.17S241.23,642,241.23,642s-6.08-154.11-43-167.6S29.29,450.69,29.29,450.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-michelle-7",
    d: "M95.9,186.3S46.38,293.54,42.79,294.43a29.27,29.27,0,0,1-6.86.81,1.65,1.65,0,0,1-1.64-2c1.58-8,29.15-88.93,37.8-94.08C72.09,199.19,95.78,181.81,95.9,186.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-michelle-11",
    d: "M92.43,211.78s-2.34-21.34,3.47-25.48S110.53,193,110.53,193s-2.12,14.75,3.35,17.09S95.67,217.81,92.43,211.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-michelle-1",
    d: "M102.42,25.19s-25.22,5.25-33,18.5a60.67,60.67,0,0,0-8,34.46c.42,8.41-2.73,13.45-2.31,17.24s4,11.56,3.15,16.81-2.52,20.18,4.62,30.69,7.78,17,12.82,22.69a125.92,125.92,0,0,1,13.43,19.34c2.34,4.48,9.93,11.17,23.27,7.13,0,0,32.1-20.16,37.38-27s14.42-24.81,14.42-36.29c0,0,3.18,5.73,10.77,1.67s-7.42-95-26.13-103.63S102.42,25.19,102.42,25.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-michelle-11",
    d: "M108.7,209.18s16.75,1.67,25.29-4.86,12.28-8.4,16.57-19.75c4-10.59,12.82-22.35,25.71-23,7.51-.4,13.48.78,14.46,7.46s-5,25.1-9,32.13-40.85,37.34-48,35.83-10.35-4.22-16.07-3.85c-10.38.67-27.29-11.38-25.12-27.12S108.7,209.18,108.7,209.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-michelle-7",
    d: "M180.23,211.38s-42,45.89-70.74,88.89a2.24,2.24,0,0,0,.48,3l11.46,9.12a2.26,2.26,0,0,0,3.12-.32c8.7-10.45,55.33-66.17,61.23-67.8C185.78,244.26,182.32,210.93,180.23,211.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-michelle-5",
    d: "M200.28,313.81a.28.28,0,0,1,.52-.21c2,3.71,5.59,11.51,5.57,15.87,0,8.56-2.72,32.51,3.23,47.4,0,0-1.92,2-3.42,2.23,0,0-5.37-13.07-4.17-34.16C202.85,330.09,202,320.26,200.28,313.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-michelle-12",
    d: "M171.45,128.23c-.42,2.05-1.75,9.81-.42,15.65s6.2,4.71,7.28,3.07c2.69-4.09.08-13.9-.5-15.94l-1.34.49c.17,2.28,1,14.18-.87,13.58-2-.66-3.07-14.32-2.89-16.79S171.7,127,171.45,128.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-michelle-13",
    d: "M86.71,156.63s3.35,8.83,11.23,9c10,.23,14.5-7.94,15.61-10.4.71-1.58,2.38-2.89,2.48-3.27C116,152,97.12,152.86,86.71,156.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-michelle-14",
    d: "M84.66,154.17s2.62-.57,3.36-1.8a3.8,3.8,0,0,1,3.2-2.13c1.39,0,3.19,2,5.4,1.39s4.59-2.38,7.3-1.31,10,2,14.91-.17c0,0-4.83,3.69-8.27,3.69s-5,.82-6,1.56-5.73,2.37-8.11,2-3.69-1.15-5.74-.74S85.56,157.2,84.66,154.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-michelle-3",
    d: "M131.69,27.78s4.11,29.74,15.71,39.65,26.35,26.11,27.32,39.64.67,30.49,14.26,43.52a19.32,19.32,0,0,0-6.52,17.4c1.45,11.36-6.77,23.21-6.29,37s9.19,26.11,6.05,36-6.77,18.86,4.59,28.28c0,0-.48-12.33,6-16.43s15.23-15,15.23-23.21c0,0,11.85,13.78-1.69,34.33,0,0,15.23-7,14.75-29.5A31.94,31.94,0,0,1,226,257s10.4-23,0-40.85c0,0,18.13,4.59,23.45,13.3,0,0-4.83-18.13-19.1-24.42,0,0,3.2-11.84-4.6-26.09,0,0,9.49-16.27-1-32.21,0,0,6.1-29.83-22.72-51.53,0,0-27.8-107.49-59.67-89.86,0,0-16.21-11.15-50.47-1.08C76.56,8.71,65.92,18,58.43,27.93c0,0,3.8,12.65,12.12,9C81.46,32.19,86,32,89.74,33.59,100.33,38.11,124.79,32.38,131.69,27.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-michelle-3",
    d: "M249.42,229.4s-4.83-18.13-19.1-24.42c0,0,3.2-11.84-4.6-26.09,0,0,9.49-16.27-1-32.21,0,0,8.11-35.77-20.71-57.47,0,0-29.81-101.55-61.68-83.92a66.85,66.85,0,0,0-7.06,10.85c-2.9,5.79-4.53,12.29-3.56,11.64,0,0,4.11,29.74,15.71,39.65s26.35,26.11,27.32,39.64.67,30.49,14.26,43.52a19.32,19.32,0,0,0-6.52,17.4c1.45,11.36-6.77,23.21-6.29,37s9.19,26.11,6.05,36-6.77,18.86,4.59,28.28c0,0-.48-12.33,6-16.43s15.23-15,15.23-23.21c0,0,11.85,13.78-1.69,34.33,0,0,15.23-7,14.75-29.5A31.94,31.94,0,0,1,226,257s10.4-23,0-40.85C226,216.1,244.1,220.69,249.42,229.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-michelle-1",
    d: "M140.52,547.4s79.14-33.6,125.66-106.58l-53.53-8.26S86.19,539.32,140.52,547.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-michelle-1",
    d: "M151.56,495.47s-21.36-5.8-33.75-1.32S60,511.48,65.08,520.52c2.83,5,32.69-3.43,32.69-3.43s-11.07,6.86-6.32,15,29.86,20,49.07,15.28S151.56,495.47,151.56,495.47Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "eyes"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-michelle-15 eyeball",
    cx: 75.72,
    cy: 100.89,
    r: 11.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-michelle-16 pupil",
    cx: 75.72,
    cy: 100.89,
    r: 7.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-michelle-15 eyeball",
    cx: 120.79,
    cy: 97.81,
    r: 12.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-michelle-16 pupil",
    cx: 120.79,
    cy: 97.81,
    r: 8.15
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMichelle);
export default __webpack_public_path__ + "static/media/Michelle.ead32b770d82df1c309187cd4d031291.svg";
export { ForwardRef as ReactComponent };